<div class="header-one">
  <div class="part-1 inline">
    <div class="part-1-1 height-30" [style.color]="textColor">{{_date}}</div>
    <div class="part-1-2 height-30" [style.backgroundColor]="opacityColor"></div>
  </div>
  <div class="part-2 inline">
    <div class="part-2-1 height-30" [style.borderBottomColor]="color"></div>
    <div class="part-2-2 height-30" [style.borderTopColor]="color"></div>
  </div>
  <div class="part-3 inline">
    <div class="part-3-1 height-30" [style.backgroundColor]="opacityColor" #tooltip="matTooltip"
         matTooltip="{{title}}"  [matTooltipPosition]="'above'">{{title}}</div>
    <div class="part-3-2 height-30" [style.color]="textColor">{{subTitle}} {{subTitle ? 'Credits' : ''}}</div>
  </div>
</div>
